import { useMutation, useQuery } from "@tanstack/react-query";
import { requestEdcExport, pollEdcExportStatus, downloadEdcExport, convertOdmExportToCrfsFn, autoImportStudyDesignFn } from "@/api/client";

export function useRequestExport() {
  return useMutation({
    mutationFn: requestEdcExport,
  });
}

export function useExportStatus(jobId: string | null) {
  return useQuery({
    queryKey: ["edcExportStatus", jobId],
    queryFn: () => pollEdcExportStatus({ jobId: jobId! }),
    enabled: !!jobId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === "completed" || status === "failed") return false;
      return 5000;
    },
  });
}

export function useDownloadExport() {
  return useMutation({
    mutationFn: downloadEdcExport,
  });
}

export function useConvertOdmToCrfs() {
  return useMutation({
    mutationFn: convertOdmExportToCrfsFn,
  });
}

export function useAutoImportStudyDesign() {
  return useMutation({
    mutationFn: autoImportStudyDesignFn,
  });
}
